import { notification } from 'antd';
import SuccessNotificationIcon from '../../../assets/icons/check-circle-fill.svg?react';
notification.config({
  maxCount: 1,
  duration: 2.5,
});

export const successNotification = (title: string, description?: string) => {
  notification.success({
    message: title,
    description: description,
    placement: 'bottom',
    icon: <SuccessNotificationIcon width={21} height={21} />,
  });
};

export const errorNotification = (title: string, description?: string) => {
  notification.error({
    placement: 'bottom',
    message: title,
    description: description,
    // duration: 1.5,
  });
};

export const alertNotification = (title: string, description?: string) => {
  notification.info({
    message: title,
    description: description,
    placement: 'bottom',
    // duration: 1.5,
  });
};
